(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-size-chart')) {
  customElements.define('cg-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.picker?.addEventListener('change', this.visibilityHandler); return; }
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-chart-data]').textContent);
      const options = JSON.parse(this.querySelector('[data-chart-options]').textContent);
      this.styleOption = options.find(o => o.name.toLowerCase() === 'style');
      this.sizeOption = options.find(o => o.name.toLowerCase() === 'size');
      if (!this.styleOption || !this.sizeOption) return;
      this.select = this.querySelector('[data-chart-style]');
      this.styleOption.values.forEach(value => {
        const name = typeof value === 'string' ? value : value.name;
        if (this.data[name]) this.select.add(new Option(name, name));
      });
      if (!this.select.options.length) return;
      this.unit = 'in';
      this.dialog = this.querySelector('dialog');
      const picker = this.closest('[data-cg-variant-picker]');
      const updateVisibility = () => {
        const style = picker?.querySelector(`input[data-option-position="${this.styleOption.position}"]:checked`)?.value;
        this.hidden = !this.data[style];
      };
      this.visibilityHandler = updateVisibility;
      this.picker = picker;
      picker?.addEventListener('change', updateVisibility);
      updateVisibility();
      this.querySelector('.cg-size-chart__trigger').addEventListener('click', () => {
        const root = this.closest('[data-cg-variant-picker]');
        const selected = root?.querySelector(`input[data-option-position="${this.styleOption.position}"]:checked`)?.value;
        this.selectedSize = root?.querySelector(`input[data-option-position="${this.sizeOption.position}"]:checked`)?.value;
        if (this.data[selected]) this.select.value = selected;
        this.render();
        this.dialog.showModal();
      });
      this.querySelector('[data-chart-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } });
      this.select.addEventListener('change', () => this.render());
      this.querySelectorAll('[data-chart-unit]').forEach(button => button.addEventListener('click', () => {
        this.unit = button.dataset.chartUnit;
        this.querySelectorAll('[data-chart-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.render();
      }));
    }
    disconnectedCallback() { this.picker?.removeEventListener('change', this.visibilityHandler); }
    render() {
      this.querySelector('[data-chart-caption]').textContent = `${this.select.value} · ${this.unit}`;
      const body = this.querySelector('tbody');
      body.replaceChildren();
      this.data[this.select.value].forEach(row => {
        const tr = document.createElement('tr');
        if (row[0] === this.selectedSize) tr.dataset.selected = '';
        row.forEach((value,index) => { const cell = document.createElement(index ? 'td' : 'th'); if (!index) cell.scope = 'row'; cell.textContent = index && this.unit === 'cm' ? String(Math.round(value * 2.54 * 10) / 10) : String(value); tr.append(cell); });
        body.append(tr);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
